interface Props {
  readonly onDismiss: () => void;
}

/**
 * Shown only to iOS users in a Safari tab.
 *
 * Without this, an operations tool that depends on notifications simply
 * never notifies half its users, and the failure is invisible -- no
 * error, no prompt, nothing to debug.
 */
const ShareIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true"
    fill="none" stroke="currentColor" strokeWidth="1.9"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 15V3" />
    <path d="M8 7l4-4 4 4" />
    <path d="M4 13v6a2 2 0 002 2h12a2 2 0 002-2v-6" />
  </svg>
);

export const InstallGuide = ({ onDismiss }: Props) => (
  <div className="installBar" role="note">
    <div className="installBody">
      <strong>Add to your Home Screen</strong>
      <p>
        Notifications only reach you once this is installed. Tap{' '}
        <span className="inlineIcon">
          <ShareIcon />
        </span>{' '}
        in the Safari toolbar, then choose{' '}
        <strong>Add to Home Screen</strong>.
      </p>
    </div>
    <button onClick={onDismiss} aria-label="Dismiss">
      Later
    </button>
  </div>
);
